import axios from 'axios'

const AppointmentNotificationSettingService = {
  async show () {
    return axios.get('admin/appointment-notification-settings')
  },

  async update (data) {
    return axios.put('admin/appointment-notification-settings', data)
  }
}

export default AppointmentNotificationSettingService
